var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 9H6.33333V5.33333H5.66667V9ZM6 4.38467C6.11622 4.38467 6.21367 4.34533 6.29233 4.26667C6.371 4.188 6.41033 4.09056 6.41033 3.97433C6.41033 3.85811 6.371 3.76067 6.29233 3.682C6.21367 3.60344 6.11622 3.56417 6 3.56417C5.88378 3.56417 5.78633 3.60344 5.70767 3.682C5.629 3.76067 5.58967 3.85811 5.58967 3.97433C5.58967 4.09056 5.629 4.188 5.70767 4.26667C5.78633 4.34533 5.88378 4.38467 6 4.38467ZM6.00217 12C5.1725 12 4.39244 11.8426 3.662 11.5277C2.93167 11.2128 2.29633 10.7854 1.756 10.2457C1.21567 9.70589 0.787944 9.07111 0.472833 8.34133C0.157611 7.61167 0 6.83194 0 6.00217C0 5.1725 0.157444 4.39244 0.472333 3.662C0.787222 2.93167 1.21456 2.29633 1.75433 1.756C2.29411 1.21567 2.92889 0.787944 3.65867 0.472833C4.38833 0.157611 5.16806 0 5.99783 0C6.8275 0 7.60756 0.157445 8.338 0.472334C9.06833 0.787223 9.70367 1.21456 10.244 1.75433C10.7843 2.29411 11.2121 2.92889 11.5272 3.65867C11.8424 4.38833 12 5.16806 12 5.99783C12 6.8275 11.8426 7.60756 11.5277 8.338C11.2128 9.06833 10.7854 9.70367 10.2457 10.244C9.70589 10.7843 9.07111 11.2121 8.34133 11.5272C7.61167 11.8424 6.83194 12 6.00217 12Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.1a8b6f31626ef9e0e39403180710c377.svg";
export { ForwardRef as ReactComponent };